import { render, staticRenderFns } from "./InputList.vue?vue&type=template&id=2b1fe96c&scoped=true&"
import script from "./InputList.vue?vue&type=script&lang=ts&"
export * from "./InputList.vue?vue&type=script&lang=ts&"
import style0 from "./InputList.vue?vue&type=style&index=0&id=2b1fe96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fe96c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCheckbox,VRadio,VRadioGroup})
